import { store } from 'index'
import * as REDUX_TYPES from '../types'

export const resetPlayerControls = () => {
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.RESET
    }
}
export const setMediaDuration = (mediaDuration) => {
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.MEDIA_DURATION,
        mediaDuration
    }
}

export const setHideControls = (hideControls) => {
    console.log(`setHideControls ${hideControls}`)
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.HIDE_CONTROLS,
        hideControls,
    }
}
export const setMuted = (muted) => {
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.MUTED,
        muted
    }
}

export const setPlaying = (playing) => {
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.PLAYING,
        playing,
    }
}

export const setPreview = (preview) => {
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.PREVIEW,
        preview,
    }
}
export const setUserInteracted = (userInteracted) => {
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.USER_INTERACTED,
        userInteracted
    }
}
export const setUserStartedPlayback = (userStartedPlayback) => {
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.USER_STARTED_PLAYBACK,
        userStartedPlayback
    }
}
export const setUserMutedMedia = (userMutedMedia) => {
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.USER_MUTED_MEDIA,
        userMutedMedia
    }
}
export const setUserPausedMedia = (userPausedMedia) => {
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.USER_PAUSED_MEDIA,
        userPausedMedia
    }
}
export const setVideoPlaying = (videoPlaying) => {
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.VIDEO_PLAYING,
        videoPlaying
    }
}
export const toggleControls = () => {
    const { hideControls } = store.getState().playerControls
    return {
        type: REDUX_TYPES.PLAYER_CONTROLS.HIDE_CONTROLS,
        hideControls: !hideControls
    }
}
